import { Guid, IBaseModel, Code } from '~/interfaces/base'
import emptyId from '~/statics/empty-id'

export class WorkPlaceStatus implements IBaseModel {
  id: Guid
  code: Code
  name: string
  taxFreePercent: number
  finanaceCode: string

  constructor() {
    this.id = emptyId
    this.code = ''
    this.name = ''
    this.taxFreePercent = 0
    this.finanaceCode = ''
  }
}